import React, { Component } from "react";

export default class Footer extends Component {
  year = new Date().getFullYear();

  render() {
    return (
      <div className="footer">
        Copyright {this.year} Honda Car India - All Rights Reserved.
      </div>
    );
  }
}
